import { render, staticRenderFns } from "./ChatInstagram.vue?vue&type=template&id=7c78c2fe&"
import script from "./ChatInstagram.vue?vue&type=script&lang=js&"
export * from "./ChatInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports